









































































































































import { binaryApi } from "@/api/api";
import { ApiGetContractLineDtoType, ApiGetContractWithFileDto } from "@/api/generated/Api";
import ContractModal from "@/components/course/contract/ContractModal.vue";
import BaseModal from "@/components/shared/BaseModal.vue";
import BaseTooltipIconButton from "@/components/shared/button/BaseTooltipIconButton.vue";
import BaseSheet from "@/components/shared/sheet/BaseSheet.vue";
import BaseSheetField from "@/components/shared/sheet/BaseSheetField.vue";
import BaseSheetHeader from "@/components/shared/sheet/BaseSheetHeader.vue";
import BaseTableSimple from "@/components/shared/table/BaseTableSimple.vue";
import { ModalType } from "@/shared/enums/modalTypeEnum";
import { formatDate } from "@/shared/helpers/dateHelpers";
import { globalLoadingWrapper } from "@/shared/helpers/loadingHelpers";
import { runStoreAction } from "@/shared/helpers/store.helpers";
import { useRoute, useStore } from "@/shared/useHelpers";
import { StoreModules } from "@/store/store-modules.enum";
import { StoreActions } from "@/store/store.actions";
import { StoreState } from "@/store/store.state.interface";
import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import fileDownload from "js-file-download";
import { getStatusText } from "@/shared/helpers/resourceHelpers";
import { isValidStringProperty } from "@/shared/helpers/typeHelpers";
import { genderMap } from "@/components/course/details/participant/ParticipantGeneralInfo.vue";

export default defineComponent({
  name: "ViewCustomer",
  components: {
    BaseSheet,
    BaseSheetHeader,
    BaseSheetField,
    BaseModal,
    BaseTableSimple,
    BaseTooltipIconButton,
    ContractModal,
  },
  setup() {
    const store = useStore<StoreState>();
    const route = useRoute();

    const showModal = ref(false);
    const modalHeadline = ref("");
    const modalType = ref("");
    const currentContractId = ref(0);

    const currentUserId = computed(() => +route.params.resourceId);
    const currentCourseId = computed(() => +route.params.id);

    const contractId = computed(() => currentContractId.value);

    const resource = computed(() => store.state.contacts.contactSingle);
    const contracts = computed(() => store.state.contracts.contracts);
    const getContact = computed(() => store.state.contacts.contactSingle);

    const contractIsSigned = (item: ApiGetContractWithFileDto) =>
      item.status === "signed" && item.contractFile?.signedFileId;
    const viewContract = (item: ApiGetContractWithFileDto) => {
      currentContractId.value = item.id;
      modalHeadline.value = "Vis kontrakt";
      modalType.value = ModalType.Display;
      showModal.value = true;
    };
    const editContract = (item: ApiGetContractWithFileDto) => {
      currentContractId.value = item.id;
      modalHeadline.value = "Rediger kontrakt";
      modalType.value = ModalType.Edit;
      showModal.value = true;
    };
    const newContract = () => {
      currentContractId.value = 0;
      modalHeadline.value = "Opprett ny kontrakt";
      modalType.value = ModalType.Add;
      showModal.value = true;
    };

    const getGender = (genderString: string) => {
      const gender = genderString?.toLowerCase();
      if (isValidStringProperty(genderMap, gender)) {
        return genderMap[gender];
      }
      return "Ukjent";
    };

    const contractIsEditable = (item: ApiGetContractWithFileDto) => item.status === "not_sent";
    // Iterates thorugh all contractLines, returning sum by price.
    const getHoursSummary = (item: ApiGetContractLineDtoType[]) =>
      item.reduce((sum: number, { amount }: ApiGetContractLineDtoType) => sum + (amount || 0), 0);
    const formatBirthDate = (birthDate: string) => formatDate(birthDate);
    const downloadContract = async (item: ApiGetContractWithFileDto) => {
      globalLoadingWrapper({ blocking: true }, async () => {
        if (!item.contractFile || !item.contractFile.signedFileId) {
          return;
        }
        const contractFile = await binaryApi.file.downloadFileAsync(item.contractFile.signedFileId, { format: "blob" });
        const generatedFilename = `${resource.value.customer.lastName}_${resource.value.customer.firstName}_contractid${item.id}.pdf`;
        fileDownload(contractFile.data, generatedFilename);
      });
    };

    const closeModalAndUpdateContracts = async () => {
      await setPerson();
      await fetchContracts();
      showModal.value = false;
    };
    const setPerson = async () => {
      globalLoadingWrapper({ blocking: true }, async () => {
        await runStoreAction(
          store,
          StoreModules.Contacts,
          StoreActions.ContactsActions.FetchPerson,
          currentUserId.value
        );
      });
    };
    const fetchContracts = async () => {
      globalLoadingWrapper({ blocking: true }, async () => {
        const payload = {
          courseId: currentCourseId.value,
          userId: currentUserId.value,
        };

        await runStoreAction(store, StoreModules.Contracts, StoreActions.ContractActions.FetchContracts, payload);
      });
    };

    const refresh = () => {
      fetchContracts();
    };

    onMounted(async () => {
      await setPerson();
      await fetchContracts();
    });

    return {
      formatDate,
      showModal,
      modalHeadline,
      modalType,
      currentUserId,
      currentCourseId,
      resource,
      contracts,
      refresh,
      viewContract,
      editContract,
      newContract,
      fetchContracts,
      headers,
      closeModalAndUpdateContracts,
      contractIsEditable,
      getHoursSummary,
      formatBirthDate,
      downloadContract,
      getContact,
      contractId,
      contractIsSigned,
      getStatusText,
      getGender,
    };
  },
});
const headers = [
  {
    text: "Status",
    value: "status",
  },
  {
    text: "Opprettet",
    value: "inserted",
  },
  {
    text: "Lønnsmottaker?",
    value: "isSelfEmployed",
  },
  {
    text: "Sum timer",
    value: "contractLines",
  },
  { text: "Handlinger", value: "actions", sortable: false },
];
